import React, { Fragment } from 'react';
// react library that creates nice scrollbar on windows devices
import { broadCastService } from 'services/notifications/BroadCastService';
import { notificationService } from 'services/notifications/NotificationService';
import { putDispositionStatus } from 'services/http/appointment';
import CalendarDispositionAlert from './notificationTypes/calendarDispositionAlert';
import * as storage from "services/utility/storage";
import appConstant from 'constants/app';
import { connect } from 'react-redux';
import notificationAlertSrc from '../../assets/audio/chime_002.mp3';

class SignalrNotificationAlert extends React.Component {
    constructor() {
        super();
        this.myRef = React.createRef();
        this.state = {         
            notificationSubscription: null,
            notifications: []          
        }
    }

    componentDidMount = () => {
        const notificationSubscription = broadCastService.receiver().subscribe(this.onNotificationReceived);
        this.setState({ notificationSubscription }); 
    }

    onNotificationReceived = (notification) => {
        if (notification.type !== 'calendarDispositionNotify') {
            return;
        }

        //console.log('Notification recived:', notification);
        const { notifications } = this.state;
        const _notification = {
            ...notification,
            isSeen: false
        }
        this.myRef.current.play();
        this.setState({ notifications: [...notifications, _notification] });
    }

    componentWillUnmount = () => {
        const { notificationSubscription } = this.state;
        notificationSubscription.unsubscribe();
    } 

    saveDispositionStatus = (dispositionStatusId, data, index) => {
        let token = null;
        if (this.props.companyCode !== data.companyCode) {
            let companiesTokens = storage.getLocalStorage(appConstant.TOKENS)
            let companyToken = companiesTokens.find(item => item.code === data.companyCode);
            if (companyToken) {
                token = companyToken.token;
            }
        }

        if (!dispositionStatusId) {
            const obj = {
                appointment_id: data.appointmentId,
                disposition_status: 7,
                userId: data.userId
            };
            putDispositionStatus(obj, token).then((response) => {
                if (response.success) {
                    if (index >= 0) {
                        this.removeNotificationAndClose(index);
                    }
                }
            }).catch((response) => {
                notificationService.sendErrorMessage("An unknown error has occurred. Please try again. You can contact us at support@debtonator.us if the problem persists.");
            });
        }
        else {
            const obj = {
                appointment_id: data.appointmentId,
                disposition_status: dispositionStatusId,
                userId: data.userId
            };

            putDispositionStatus(obj, token).then((response)=> {
                if (response.success) {
                    if (index >= 0) {
                        this.removeNotificationAndClose(index);
                    }
                }
            }).catch((response)=> {
                notificationService.sendErrorMessage("An unknown error has occurred. Please try again. You can contact us at support@debtonator.us if the problem persists.");
            });
        }
    };
    
    removeNotificationAndClose=(index)=>{
        const { notifications } = this.state;
        if (notifications.length > 0) {
            notifications.splice(index, 1);
            this.setState({ notifications });
        }
    }    

    getUniqueId =(max)=>{
       return Math.random() * max;
    }

    getUniqueId =  ()=> {      
        return '_' + Math.random().toString(36).substr(2, 9);
      };

    render() {
        const { notifications } = this.state;
        return (
            <Fragment>
                {notifications.map((notification, index) =>                   
                    <CalendarDispositionAlert 
                    notification={notification} 
                    key={this.getUniqueId()} 
                    index={index} 
                    saveDispositionStatus={this.saveDispositionStatus}
                     />
                )}
            <audio ref={this.myRef} autoPlay={false}><source src={notificationAlertSrc} type="audio/mpeg"></source></audio>
            </Fragment>)
    }
}

const mapStateToProps = (state) => {
    return {
        companyCode: state.company.code,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(SignalrNotificationAlert)